export async function getList({commit}, payload) {
  const {errResponse, data: responseData} = await this.$adminRepositories.requestEbooks.index(payload);
  if (!errResponse && responseData.success) {
    return commit('setList', responseData.data);
  }
  return [];
}

export async function updateStatus({commit}, payload) {
  const response = await this.$adminRepositories.requestEbooks.updateStatus(payload.id, payload);
  return response;
}
